"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Chat_1 = require("../Chat");
const ChatMessage_1 = require("../ChatMessage");
class ChatFactory {
    constructor(isService, chatRepo, cmdHub, evtHub, cmas) {
        this._isService = isService;
        this._chatRepo = chatRepo;
        this._commandHub = cmdHub;
        this._eventHub = evtHub;
        this._chatMessageAttachmentService = cmas;
    }
    NewChatFromParticipants(participants) {
        const chat = Chat_1.Chat.NewChatWithNoSpecifiedId(participants, Chat_1.Chat.NO_SPECIFIED_CREATE_TIME, this._isService, this._chatRepo, this._commandHub, this._eventHub, this._chatMessageAttachmentService);
        return chat;
    }
    NewChatFromIdAndParticipants(id, participants) {
        const chat = Chat_1.Chat.NewChat(id, participants, Chat_1.Chat.NO_SPECIFIED_CREATE_TIME, this._isService, this._chatRepo, this._commandHub, this._eventHub, this._chatMessageAttachmentService);
        return chat;
    }
    NewChatFromChatMessage(cm, participants = [], doesAcceptArbitraryId = false) {
        const chat = Chat_1.Chat.NewChatFromChatMessage(cm, participants, doesAcceptArbitraryId, this._isService, this._chatRepo, this._commandHub, this._eventHub, this._chatMessageAttachmentService);
        if (chat === Chat_1.Chat.INVALID_CHAT)
            return chat;
        chat.id = this._chatRepo.GenerateId(participants);
        return chat;
    }
    NewChatFromEncodedId(encodedId, needToSpecifyId = Chat_1.Chat.NO_SPECIFIED_ID) {
        const chat = Chat_1.Chat.NewChatFromEncodedId(encodedId, Chat_1.Chat.NO_SPECIFIED_CREATE_TIME, this._isService, this._chatRepo, this._commandHub, this._eventHub, this._chatMessageAttachmentService);
        if (chat === Chat_1.Chat.INVALID_CHAT)
            return chat;
        if (needToSpecifyId !== Chat_1.Chat.NO_SPECIFIED_ID) {
            chat.id = needToSpecifyId;
        }
        return chat;
    }
    NewChatFromMostProperties(specifiedId, name, creatorName, tags, participants) {
        const chat = Chat_1.Chat.NewChatAll(specifiedId, name, creatorName, tags, participants, Chat_1.Chat.NO_SPECIFIED_CREATE_TIME, this._isService, this._chatRepo, this._commandHub, this._eventHub, this._chatMessageAttachmentService);
        return chat;
    }
    NewChatFromChat(chat) {
        return new Chat_1.Chat(this._isService, this._chatRepo, this._commandHub, this._eventHub, this._chatMessageAttachmentService, chat);
    }
    NewChatFromChatDto(chatDto) {
        return new Chat_1.Chat(this._isService, this._chatRepo, this._commandHub, this._eventHub, this._chatMessageAttachmentService, {
            id: chatDto.id,
            TempId: chatDto.tempId,
            Name: chatDto.name,
            Tags: chatDto.tags,
            Participants: new Set(chatDto.participants),
            ParticipantReadCounts: new Map(chatDto.participantReadCounts),
            EndedFor: new Set(chatDto.endedFor),
            Messages: chatDto.messages.map(cmDto => ChatMessage_1.ChatMessage.FromChatMessageDto(this._isService, this._commandHub, this._eventHub, cmDto)),
            CreatedFrom: chatDto.createdFrom,
            TotalChatMessageCount: chatDto.totalChatMessageCount,
        });
    }
}
exports.ChatFactory = ChatFactory;
//# sourceMappingURL=ChatFactory.js.map